import { Navigate, useLocation } from 'react-router-dom';
import { ROUTE_AUTHENTICATION, ROUTE_MAIN } from '@/app/routes';
import { getAuthenticated, getSignedOutByUser } from '@/services/authSlice';
import { useAppSelector } from '@/app/hooks';
import React, { JSX, PropsWithChildren } from 'react';

export const PrivateRoute = ({ children }: PropsWithChildren): JSX.Element | null => {
  const isAuthenticated = useAppSelector(getAuthenticated);
  const isSignedOutByUser = useAppSelector(getSignedOutByUser);
  const location = useLocation();
  if (!isAuthenticated) {
    // Someone who has just signed out is finished, so a login form reads as though something had gone wrong;
    // they go to the public main page instead.
    // Every deliberate sign-out also navigates there itself,
    // and the two agreeing is what makes the outcome independent of which of them React commits first.
    if (isSignedOutByUser) {
      return <Navigate to={ROUTE_MAIN} replace={true} />;
    }
    // Everyone else arriving without a session wants the form: a session the server ended,
    // and a visitor opening a cabinet address for the first time. Both are returned to this page afterwards.
    return <Navigate to={ROUTE_AUTHENTICATION} state={{ redirectTo: location.pathname }} replace={true} />;
  }

  return <>{children}</>;
};
